module.exports = __webpack_public_path__ + "img/btn_google_signin_dark_normal_web@2x.56f00e35.png";